import { render, staticRenderFns } from "./_NotifAskAccess.vue?vue&type=template&id=7cd70892&scoped=true&"
import script from "./_NotifAskAccess.vue?vue&type=script&lang=js&"
export * from "./_NotifAskAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd70892",
  null
  
)

export default component.exports